import { convertConditionGroups } from './convertConditionGroups';
import { convertEvent } from './convertEvent';
import { IConvertRule, IRule } from './entities';

export function convertRule({
	rule,
	statement,
	conditionGroup,
	actions,
	formData,
	getFactKeys
}: IConvertRule): IRule {
	const convertedRule: IRule = {
		conditions: convertConditionGroups(conditionGroup, formData, getFactKeys),
		event: convertEvent(actions, rule, getFactKeys),
		id: rule.id,
		statement
	};

	return convertedRule;
}
